import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useForm } from 'react-hook-form'
import { func, bool } from 'prop-types'
import { Dialog } from '@material-ui/core'
import { Row, Col } from '@gympass/yoga'

import { PlayButton } from '@assets/icons'

import Appbar from '@components/Appbar'
import SideDialog from '@components/SideDialog'
import LocationButton from '@components/LocationButton'
import CountryLanguageDialogContent from '@components/CountryLanguageDialog'

import * as Style from './Header.style'
import { Container } from '../../Home.style'

import useValidation from './Header.validation'

const Header = ({ onSubmit, onLoading }) => {
  const intl = useIntl()
  const [showVideo, setShowVideo] = useState(false)
  const [showLocationDialog, setShowLocationDialog] = useState(false)

  const validationSchema = useValidation()

  const { register, handleSubmit, errors } = useForm({
    validationSchema,
  })

  function toggleVideoDialog() {
    setShowVideo(!showVideo)
  }

  function openLocationDialog() {
    setShowLocationDialog(true)
  }

  function closeLocationDialog() {
    setShowLocationDialog(false)
  }

  return (
    <>
      <Appbar>
        <LocationButton onClick={openLocationDialog} />
      </Appbar>
      <Style.HeaderStyled>
        <Container>
          <Row>
            <Col xxs={12} xl={6}>
              <SideDialog
                open={showLocationDialog}
                title={intl.messages['smb_acquisition_language_panel.title']}
                onClose={closeLocationDialog}
              >
                <CountryLanguageDialogContent />
              </SideDialog>

              <Style.HeaderTitle>
                <FormattedMessage
                  id="smb_acquisition_home.header.title"
                  values={{
                    strong: (...chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </Style.HeaderTitle>

              <Style.HeaderSubtitle light>
                <FormattedMessage id="smb_acquisition_home.header.subtitle" />
              </Style.HeaderSubtitle>
              <Style.FormWrapper>
                <Style.RelativeContainer>
                  <Style.Form>
                    <Style.Input
                      name="email"
                      ref={register}
                      placeholder={
                        intl.messages[
                          'smb_acquisition_home.lead_capture.email.placeholder'
                        ]
                      }
                    />
                    <Style.FormAction>
                      <Style.FormButton onClick={handleSubmit(onSubmit)} full>
                        {onLoading ? (
                          <Style.Progress
                            style={{ width: 35, height: 'auto' }}
                          />
                        ) : (
                          <FormattedMessage id="smb_acquisition_home.lead_capture.call_to_action.default" />
                        )}
                      </Style.FormButton>
                    </Style.FormAction>
                  </Style.Form>

                  <Style.StyledReCaptcha id="g-recaptcha" />

                  <Style.ErrorMessage>
                    {errors.email && errors.email.message}
                  </Style.ErrorMessage>
                </Style.RelativeContainer>

                <Style.VideoButtonWrapper onClick={toggleVideoDialog}>
                  <img src={PlayButton} alt="Botão de play" />
                  <p>
                    <FormattedMessage id="smb_acquisition_home.media.how_it_works" />
                  </p>
                </Style.VideoButtonWrapper>
              </Style.FormWrapper>

              <Dialog
                open={showVideo}
                onClose={toggleVideoDialog}
                maxWidth="xl"
              >
                <Style.DialogContent>
                  <Style.VideoWrapper>
                    <iframe
                      title="gympass-smb-video"
                      src="https://www.youtube.com/embed/LVCCfbd0Ti4"
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </Style.VideoWrapper>
                </Style.DialogContent>
              </Dialog>
            </Col>
          </Row>
        </Container>
      </Style.HeaderStyled>
    </>
  )
}

Header.propTypes = {
  onSubmit: func.isRequired,
  onLoading: bool.isRequired,
}

export default Header
